import { Callout, H3, Icon, Tag } from "@blueprintjs/core";
import { Users } from "@just-in-types";
import * as React from "react";
import styled from "react-emotion";
import { Link } from "react-router-dom";
import "../styles/home.css";
// import UpdateCallout from "../components/UpdateCallout";

interface IHomeProps {
  currentUser: null | Users.User | Users.UserWithAccount;
  permissions: Users.Permissions;
}

const HomeBody = styled("div")`
  max-width: 32rem;
  text-align: center;
  margin: 1rem auto;
`;

export const firstLetterUppercase = (value: string) =>
  value.charAt(0).toUpperCase() + value.substr(1);

const staffText = (
  <img
    src="https://www.texnrewards.com/wp-content/uploads/2020/08/TexnRewards_mobile_connection-01.jpg"
    height={200}
    width={300}
  />
  // <p>
  //   Right now, this page doesn't really do anything, so use the navigation bar
  //   at the top of this page to view check-ins. Over time, I'll add relevant
  //   information for you here: updates, bug fixes, and such.
  // </p>
);
const waitingText = (
  <img
    src="https://www.texnrewards.com/wp-content/uploads/2020/08/TexnRewards_mobile_connection-01.jpg"
    height={200}
    width={300}
  />
);
const noUserText = (
  <>
    <img
      src="https://www.texnrewards.com/wp-content/uploads/2020/08/TexnRewards_mobile_connection-01.jpg"
      height={200}
      width={300}
    />
    <p>Please sign in at the top of the page if you've been here before.</p>
    <p>
      If you're trying to sign up to use this system, please click the button on
      the top-right of your screen that says 'sign in'. Then, click 'create
      account' and fill in your email and password. Once you're done, contact
      someone at Texn Rewards (or your manager) so we can set up your account.
    </p>
    <p>
      If you need any help, please email{" "}
      <Tag minimal={true}>support@texnrewards.com</Tag> and we'll get back to
      you as fast as we can
    </p>
  </>
);
class Home extends React.Component<IHomeProps> {
  public render() {
    const {
      currentUser,
      permissions: { role },
    } = this.props;

    // const role = 'owner';

    const calloutTitle = currentUser
      ? role !== "user"
        ? `Welcome, ${firstLetterUppercase(role)}!`
        : "Just a sec..."
      : "Time to sign up/in!";
    const calloutText = currentUser
      ? role !== "user"
        ? staffText
        : waitingText
      : noUserText;

    let homeArr: any = [];

    if (role === "staff") {
      homeArr = [
        {
          icon: 'saved',
          path: '/check-ins',
          text: '<li>Track your daily customer attendance</li>',
          title: 'Check Ins',
        },
      ];
    } else if (role === "owner") {
      homeArr = [
        {
          icon: 'saved',
          path: '/check-ins',
          text: '<li>Track your daily customer attendance</li>',
          title: 'Check Ins',
        },
        {
          icon: 'new-person',
          path: '/pro-members',
          title: 'Pro Member',
        },
        {
          icon: 'chart',
          path: '/reports',
          text: '<li>Signup for Check-ins and Vehical Picks Reports</li>',
          title: 'Report',
        },
      ];
    } else if (role === "admin") {
      homeArr = [
        {
          icon: 'saved',
          path: '/check-ins',
          text: '<li>Track your daily customer attendance</li>',
          title: 'Check Ins',
        },
        {
          icon: "new-person",
          path: "/pro-members",
          title: "Pro Members",
        },
        {
          icon: 'chart',
          path: '/reports',
          text: '<li>Signup for Check-ins and Vehical Picks Reports</li>',
          title: 'Report',
        },
        {
          icon: "briefcase",
          path: "/businesses",
          title: "Businesses",
        },
        {
          icon: "user",
          path: "/users",
          title: "Users",
        },
        {
          icon: "graph",
          path: "/scheduled-reports",
          title: "Scheduled Reports",
        },
        {
          icon: "layout-circle",
          path: "/wheel-options",
          title: "Wheel Options",
        },
        {
          icon: "cog",
          path: "/admin",
          title: "Admin",
        },
        {
          icon: "list-columns",
          path: "/inventory",
          title: "Inventory",
        },
      ];
    }

    homeArr.push({
      icon: "panel-stats",
      isExternal: true,
      path: 'https://www.texnrewards.com/blog/',
      text: '<li>Stay up-to-date on new features and industry insights</li>',
      title: 'Blog',
    })

    const arrayChunks = (arr: any[], len: number) => {
      const chunks: any[] = [];
      let i = 0;
      const n = arr.length;

      while (i < n) {
        chunks.push(arr.slice(i, (i += len)));
      }

      return chunks;
    };

    const homeArrChunk = arrayChunks(homeArr, 3);

    return (
      <div className="home-content">
        <HomeBody>
          <Callout title={calloutTitle}>{calloutText}</Callout>
          <br />
          {/* <UpdateCallout /> */}
        </HomeBody>
        {currentUser &&
          homeArrChunk.map((chunk) => (
            <div className="elementor-container">
              <div className="elementor-row">
                {chunk.map((ele, index) => (
                  <div
                    key={index}
                    className="elementor-column elementor-col-25"
                  >
                    <div className="elementor-column-wrap elementor-element-populated">
                      <div className="elementor-widget-container">
                        <div className="elementor-icon-box-icon">
                          <Icon
                            className="elementor-icon"
                            icon={ele.icon}
                            iconSize={50}
                          />
                        </div>
                        <div className="elementor-icon-box-content">
                          <H3 className="elementor-icon-box-title">
                            {ele.isExternal ? (
                              <a href={ele.path} target="_blank">
                                {ele.title}
                              </a>
                            ) : (
                              <Link to={ele.path}>{ele.title}</Link>
                            )}
                          </H3>
                          {ele.text ? (
                            <ul
                              className="customList1"
                              dangerouslySetInnerHTML={{ __html: ele.text }}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        {currentUser && (
          <div className="elementor-container blog-iframe">
            <div className="elementor-row">
              <div className="elementor-column">
                <div className="elementor-heading">
                  <H3 className="elementor-heading-title">Latest Blogs</H3>
                </div>
                <div className="elementor-iframe">
                  <iframe src="https://www.texnrewards.com/blog" />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/views/Home.tsx